import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoPersonCircleOutline } from 'react-icons/io5';
import { IoMdCart, IoMdMenu } from 'react-icons/io';
import utils from '../../utils';
import { useAuth } from '../../context/UserContext';
import { useCart } from '../../context/CartContext';
import Search from './Search';

function NavLink({ to, children, icon, badge }) {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <Link
            to={to}
            className={`flex items-center gap-1 px-2 py-1 transition-colors duration-300
        ${isActive
                    ? 'font-bold text-secondary border-b-2 border-secondary'
                    : 'hover:text-secondary'
                }`}
        >
            {icon && <span className="text-xl">{icon}</span>}
            <span>{children}</span>
            {badge != null && (
                <span className="ml-1 px-1.5 py-0.5 text-xs font-bold bg-secondary text-black rounded-full">
                    {badge}
                </span>
            )}
        </Link>
    );
}

export default function NavBar() {
    const { isAuth } = useAuth()
    const { numCartItems } = useCart()

    return (
        <nav className="bg-gray-900 text-white shadow-md sticky top-0 z-10">
            <div className="container mx-auto px-4">
                <div className="flex justify-between items-center py-4">
                    <Link to="/" className="text-lg md:text-2xl font-black">
                        {utils?.siteName}
                    </Link>

                    <div className="hidden lg:flex items-center space-x-3 text-md">
                        <NavLink to="/products">Products</NavLink>
                        <NavLink to="/categories">Categories</NavLink>
                        <NavLink to="/about">About</NavLink>
                        <NavLink to="/contact">Contact</NavLink>
                    </div>

                    <div className="flex items-center space-x-2 md:space-x-3 text-sm md:text-md justify-end">
                        <div className="hidden md:block">
                            <Search/>
                        </div>
                        {!isAuth ? (
                            <>
                                <NavLink to="/auth/login">Login</NavLink>
                                <NavLink to="/auth/register">Register</NavLink>
                            </>
                        ) : null}

                        <NavLink
                            to="/cart"
                            icon={<IoMdCart className="h-6 w-6" />}
                            badge={numCartItems}
                        />

                        {isAuth && (
                            <NavLink
                                to="/auth/profile"
                                icon={<IoPersonCircleOutline className="h-6 w-6" />}
                            />
                        )}

                        <label
                            htmlFor="nav-drawer"
                            className="btn btn-ghost btn-sm text-white hover:text-secondary"
                            aria-label="Open menu"
                        >
                            <IoMdMenu className="h-6 w-6" />
                        </label>
                    </div>
                </div>
            </div>
        </nav>
    );
}